import { defineStore } from "pinia"
import { config } from '../assets/config.js'

import { getAuth } from "firebase/auth"
import axios from "axios"

export const useAuthStore = defineStore("authentication", {
  state: () => ({
    permissions: null,
    weight: 0,
    initialized: false,
  }),
  getters: {
    getPermissions: (state) => state.permissions,
    getUserWeight: (state) => state.weight,
  },
  actions: {
    async initializeAuthStore() {
      await this.setPermissions()
      await this.setUserWeight()

      this.initialized = true
    },

    async setUserWeight() {
      await getAuth().authStateReady()

      const user = getAuth().currentUser
      if (!user) {
        console.warn("setUserWeight() called but no user is logged in.")
        return
      }

      const token = await user.getIdToken()

      const response = await axios.get(config.api_url + '/api/user/weight', {
        headers: {
          Authorization: token
        }
      })

      this.weight = response.data
    },

    async setPermissions() {
      await getAuth().authStateReady()

      const user = getAuth().currentUser
      if (!user) {
        console.warn("setPermissions() called but no user is logged in.")
        return
      }

      const token = await user.getIdToken()

      const response = await axios.get(config.api_url + '/api/user/permissions', {
        headers: {
          Authorization: token
        }
      })

      this.permissions = response.data
    },

    hasUserPermission(permission) {
      if (this.permissions == null) return false

      return (
        this.permissions.includes(permission) ||
        this.permissions.includes("*")
      )
    },

    hasUserAccessToCategory(category) {
      if (this.permissions == null) return false

      return this.permissions.some(permission =>
        permission.startsWith(category) || permission.includes("*")
      )
    },

    async waitUntilInitialized() {
      while (this.initialized === false) {
        await new Promise(resolve => setTimeout(resolve, 50))
      }

      return true
    }
  }
})
